export type AvailablePageTemplates = {
  documentType: string;
};

export const PageTemplates: AvailablePageTemplates[] = [
  {
    documentType: 'pageHome',
  },
  {
    documentType: 'pageAppointment',
  },
  {
    documentType: 'pageThankYou',
  },
  {
    documentType: 'pageAffiliateThankYou',
  },
  {
    documentType: 'pageHowItWorks',
  },
  {
    documentType: 'pageFaq',
  },
  {
    documentType: 'pagePayout',
  },
  {
    documentType: 'pageReview',
  },
  {
    documentType: 'pageLegal',
  },
  {
    documentType: 'pageRules',
  },
  {
    documentType: 'pageAboutUs',
  },
  {
    documentType: 'pageWhyProp',
  },
  {
    documentType: 'pageChallenge',
  },
  {
    documentType: 'pageAffiliateWorkshop',
  },
  {
    documentType: 'pageManifesto',
  },
  {
    documentType: 'pageTextOnlyLP',
  },
  {
    documentType: 'pageAffiliate',
  },
  {
    documentType: 'pageAffiliateV2',
  },
  {
    documentType: 'pageCompetitionAffiliate',
  },
  {
    documentType: 'pageCompetitionAffiliateV2',
  },
  {
    documentType: 'pageEigenePrice',
  },
  {
    documentType: 'pageBlogOverview',
  },
  {
    documentType: 'pageEvent',
  },
  {
    documentType: 'pageEventThankYou',
  },
  {
    documentType: 'pageReplay',
  },
  {
    documentType: 'pageGeneralRules',
  },
  {
    documentType: 'pageAssets',
  },
  {
    documentType: 'pageAffiliateOverview',
  },
  {
    documentType: 'pageFuturesV2',
  },
  {
    documentType: 'pageFabioAffiliate',
  },
];
